import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function DeploymentModelSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    number: '1',
    title: 'Readiness Assessment',
    description: 'Organizations begin with a structured readiness evaluation to identify capability gaps, certification risks, and operational fatigue signals.'
  }, {
    number: '2',
    title: 'Pilot Deployment',
    description: 'TalentIQ integrates readiness signals across systems to generate the Readiness Index and validate operational intelligence.'
  }, {
    number: '3',
    title: 'Infrastructure Integration',
    description: 'Successful pilots expand into long-term deployments where readiness intelligence becomes part of operational planning and command decision systems.'
  }];
  return <section ref={ref} className="w-full bg-slate-950 py-24 lg:py-32 relative" data-id="element-148">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-150">
          <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight tracking-tight mb-6" data-id="element-151">
            The TalentIQ Deployment Model
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-152">
            A clear operational progression from initial assessment to
            mission-critical infrastructure.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-153">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-slate-800 -z-10" data-id="element-154" />

          {steps.map((step, i) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2 + i * 0.2
        }} className="relative bg-slate-900/50 border border-slate-800 rounded-2xl p-8 hover:border-tiq-purple/30 transition-colors duration-300 flex flex-col items-center text-center" data-id="element-155">
              <div className="w-16 h-16 rounded-full bg-slate-950 border-4 border-slate-800 flex items-center justify-center mb-6 shadow-xl z-10" data-id="element-156">
                <span className="text-2xl font-bold text-tiq-purple" data-id="element-157">
                  {step.number}
                </span>
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-158">
                {step.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-159">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}